import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import pin from "../../assets/all-images/pin.png"; // Replace with the path to your custom icon

const MapWithMarkers = () => {
  const mapCenter = [-1.286389, 36.817223]; // Nairobi coordinates

  const locations = [
    { id: 1, name: "Ruaka", coordinates: [-1.2041, 36.7654] },
    { id: 2, name: "Thika", coordinates: [-1.0387, 37.0726] },
    { id: 3, name: "Loresho", coordinates: [-1.2638, 36.7714] },
    { id: 4, name: "Westlands", coordinates: [-1.2636, 36.8109] },
    { id: 5, name: "Kiambu", coordinates: [-1.1714, 36.8362] },
    { id: 6, name: "CBD", coordinates: [-1.286389, 36.817223] }, // Nairobi coordinates
    { id: 7, name: "Muthaiga", coordinates: [-1.2459, 36.8114] },
    { id: 8, name: "Karen", coordinates: [-1.3204, 36.7023] },
    { id: 9, name: "Hurlingham", coordinates: [-1.2923, 36.7942] },
    { id: 10, name: "Embakasi", coordinates: [-1.3151, 36.9217] },
    { id: 11, name: "Ngara", coordinates: [-1.2832, 36.8232] },
    { id: 12, name: "Parklands", coordinates: [-1.2637, 36.8115] },
    { id: 13, name: "Ruiru", coordinates: [-1.1504, 36.9711] },
    { id: 14, name: "Juja", coordinates: [-1.1034, 37.0122] },
    { id: 15, name: "Kasarani", coordinates: [-1.2227, 36.8967] },
    { id: 16, name: "Imara Daima", coordinates: [-1.3187, 36.8824] },
    { id: 17, name: "South B", coordinates: [-1.3118, 36.8277] },
    { id: 18, name: "Kileleshwa", coordinates: [-1.2921, 36.7698] },
    { id: 19, name: "Ole Serani", coordinates: [-1.3159, 36.8523] },
    { id: 20, name: "Eastleigh", coordinates: [-1.2683, 36.8394] },
    { id: 21, name: "Utawala", coordinates: [-1.2942, 37.4089] },
    { id: 22, name: "Kibera", coordinates: [-1.3135, 36.7819] },
    { id: 23, name: "Outer Ring", coordinates: [-1.2633, 36.8831] },
    { id: 24, name: "Roysambu", coordinates: [-1.2255, 36.8898] },
    { id: 25, name: "Thika Road", coordinates: [-1.2126, 36.9030] },
    { id: 26, name: "Upper Hill", coordinates: [-1.3062, 36.8046] },
    { id: 27, name: "Ngong", coordinates: [-1.3544, 36.6462] },
    { id: 28, name: "Rongai", coordinates: [-1.3944, 36.7571] },
    { id: 29, name: "Wangige", coordinates: [-1.1732,  36.7455] },
    { id: 30, name: "Kabete", coordinates: [ -1.2588,  36.7066] },
    { id: 31, name: "Njiru", coordinates: [-1.2422, 36.9471] },
    { id: 32, name: "Ongata Rongai (Ololua)", coordinates: [-1.3905, 36.7425] },
    { id: 33, name: "South C", coordinates: [ -1.3184, 36.8358] },
  ];

  const customIcon = new L.Icon({
    iconUrl: pin,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  return (
    <MapContainer
      center={mapCenter}
      zoom={12}
      style={{ height: "500px", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      {locations.map((location) => (
        <Marker
          key={location.id}
          position={location.coordinates}
          icon={customIcon}
        >
          <Popup>{location.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MapWithMarkers;
